import { render, staticRenderFns } from "./SelectedAreaFee.vue?vue&type=template&id=6fe04a32&scoped=true&"
import script from "./SelectedAreaFee.vue?vue&type=script&lang=ts&"
export * from "./SelectedAreaFee.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe04a32",
  null
  
)

export default component.exports